/**
 * Appends Sanity CDN transform params so originals (some are 30MP JPEG/TIFF)
 * are never decoded at full size: 850px covers the largest card at 2x DPR,
 * auto=format serves WebP/AVIF. No-op for non-Sanity or already-transformed URLs.
 */
export const optimizeSanityImage = (url: string | null | undefined, width = 850): string | undefined => {
  if (!url || !url.includes('cdn.sanity.io') || url.includes('?')) return url ?? undefined;
  return `${url}?w=${width}&fit=max&auto=format&q=75`;
};
